<ui-tabset>
  <ui-tab [uiTitle]="'create_symbol' | localize">
    <div class="team-preview">
      <ui-avatar [uiIcon]="team.avatar" [uiBgColor]="team.color" uiTheme="fill" uiSize="lg"></ui-avatar>
      <h2>{{ team.name }}</h2>
    </div>

    <div class="icons">
      <div class="single-icon" *ngFor="let icon of icons" [ngClass]="{ selected: icon === team.avatar }" (click)="setAvatar(icon)">
        <span [ngClass]="'nc-icon-outline icon ' + icon"></span>
      </div>
    </div>

    <div class="colors">
      <div class="single-color" *ngFor="let color of colors" [style.background]="color" [ngClass]="{ selected: color === team.color }" (click)="setColor(color)"></div>
    </div>
  </ui-tab>

  <ui-tab [uiTitle]="'upload_picture' | localize">
    <div class="team-preview">
      <ui-avatar *ngIf="!imgData.pictureFile" [uiIcon]="team.avatar" [uiBgColor]="team.color" uiTheme="fill" uiSize="lg"></ui-avatar>
      <ui-avatar *ngIf="imgData.pictureFile" [uiPicture]="imgData.pictureUrl" uiSize="lg"></ui-avatar>
      <h2>{{ team.name }}</h2>
    </div>

    <div class="new-avatar">
      <image-cropper
        [imageFile]="imgData.pictureFile"
        [maintainAspectRatio]="true"
        [aspectRatio]="1 / 1"
        [roundCropper]="true"
        [hidden]="!imgData.pictureFile"
        [resizeToWidth]="200"
        [resizeToHeight]="200"
        (imageCropped)="imageCropped($event)"
        (imageLoaded)="imageLoaded($event)"></image-cropper>

      <div *ngIf="!imgData.pictureFile">
        <button (click)="inputField.click()" ui-button uiShape="round" uiType="default" uiSize="default" data-test-id="create-team-avatar-browse-button">
          <div class="mr-8px gh-font-icon-upload"></div>
          <span>{{ "browse" | localize }}</span>
        </button>
      </div>

      <input id="inputTag" #inputField [accept]="allowedImageTypes" (click)="inputField.value = ''" (change)="fileSelected($event)" hidden type="file" />

      <div class="picture-restrictions" *ngIf="!imgData.pictureFile">
        <p>{{ "recommended_image_size" | localize }}</p>
        <p>{{ "common_image_formats" | localize }}</p>
      </div>
    </div>
  </ui-tab>
</ui-tabset>
